import { styled } from 'storybook/internal/theming';

export const InformationBanner = styled.p`
  background: #ffebba;
  padding: 5px;
  margin-top: 0;
`;
